import React from "react";

/** Selectable analysis windows, narrowest first. */
const PERIODS = [
  { id: "latest", label: "Latest year" },
  { id: "2y", label: "2 years" },
  { id: "3y", label: "3 years" },
];

/** What the company's figures are measured against. */
const COMPARE_MODES = [
  { id: "peer", label: "vs peer average" },
  { id: "leader", label: "vs sector leader" },
];

/**
 * Chooses the analysis window and the comparison baseline.
 *
 * @param {object} props - Current selections and change handlers.
 * @returns {JSX.Element} The toolbar.
 *
 * @remarks
 * Both controls re-render stored data. Every series was generated across all
 * periods up front, so switching costs nothing and triggers no further AI spend.
 */
const PeriodCompareControls = ({
  period,
  compareMode,
  availableYears,
  onPeriodChange,
  onCompareChange,
}) => (
  <section className="aica-card aica-controls">
    <div className="aica-control-row">
      <span className="aica-control-label">Analysis period</span>
      <div className="aica-segment" role="group" aria-label="Analysis period">
        {PERIODS.map((entry, index) => (
          <button
            key={entry.id}
            type="button"
            className={`aica-segment-btn ${
              period === entry.id ? "is-active" : ""
            }`}
            disabled={index + 1 > availableYears}
            onClick={() => onPeriodChange(entry.id)}
          >
            {entry.label}
          </button>
        ))}
      </div>
    </div>

    <div className="aica-control-row">
      <span className="aica-control-label">Compare</span>
      <div className="aica-segment" role="group" aria-label="Compare against">
        {COMPARE_MODES.map((entry) => (
          <button
            key={entry.id}
            type="button"
            className={`aica-segment-btn ${
              compareMode === entry.id ? "is-active" : ""
            }`}
            onClick={() => onCompareChange(entry.id)}
          >
            {entry.label}
          </button>
        ))}
      </div>
    </div>
  </section>
);

export default PeriodCompareControls;
